import React from 'react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-85" data-mp="1hjhebpwvk51x">
      <div className="mx-auto w-full max-w-4xl" data-id="element-86" data-mp="1ckwkc887uhlx">
        <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="1clftp0jsvxoc">
          <span className="inline-block rounded-full bg-gold px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-88" data-mp="18k49xbnly6o2">
            Bonus esclusivi gratuiti
          </span>
          <h2 className="mt-4 font-display text-[26px] font-bold leading-[1.15] text-cream sm:text-4xl" data-id="element-89" data-mp="20a8tj83jmpo8">
            🎁 Inoltre, OGGI riceverai GRATIS questi 5 bonus esclusivi
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-cream/65" data-id="element-90" data-mp="1racapn3u4l13">
            Valore complessivo di 197 € — oggi inclusi gratuitamente con il tuo
            acquisto.
          </p>
        </div>

        <ul className="mt-9 space-y-5" data-id="element-91" data-mp="fv6tzf6vclyh">
          {bonuses.map(bonus => <li key={bonus.tag} className="overflow-hidden rounded-2xl border border-gold/20 bg-ink-soft sm:flex sm:items-center" data-id="element-92" data-mp="fx9u4s1qjvgx">
              <img src={bonus.image} alt={`Mockup del bonus ${bonus.title}`} className="w-full bg-white object-contain sm:w-[42%] sm:shrink-0" width={1254} height={1254} data-id="element-93" data-mp="1jrylul3z7q62" />
              <div className="p-5 sm:p-6" data-id="element-94" data-mp="w2x5mbowjaq8">
                <div className="flex flex-wrap items-center gap-2" data-id="element-95" data-mp="w12l2yhjlkmo">
                  <span className="rounded-full bg-gold/15 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-gold-light" data-id="element-96" data-mp="10uno54xzt4sq">
                    {bonus.tag}
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-wide text-cream/45 line-through" data-id="element-97" data-mp="r4vrm56c21lm">
                    {bonus.value}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-[19px] font-bold leading-tight text-cream sm:text-xl" data-id="element-98" data-mp="i2cpxoea9v0y">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14.5px] leading-relaxed text-cream/65" data-id="element-99" data-mp="2f1v2cxekqagm">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-100" data-mp="26159o2km1074">
          <CTAButton label="Voglio i 5 bonus gratis" data-id="element-101" data-mp="262gjaj0ql265" />
        </div>
      </div>
    </section>;
}